import { UsefulLinksStore, NewUsefulLinkStore, ChangeUsefulLinkStore } from './useful-links-store';

export function setupRepositories(storeBuilder) {
  storeBuilder.addRepository(new UsefulLinksStore());
  storeBuilder.addRepository(new NewUsefulLinkStore());
  storeBuilder.addRepository(new ChangeUsefulLinkStore());
}
